export default __webpack_public_path__ + "static/media/img-onboarding-bg.eb7b5cc6.svg";